import { useEffect } from 'react';

import useNonLoginPopupStore from '~/store/global/useNonLoginPopupStore';
import { closeCurrentModal } from '~/utils/mobileApp';

import ErrorPage from './ErrorPage';
import MarketNonLoginPopup from './MarketNonLoginPopup';

const NonLoginErrorPage = () => {
  const { openPopup } = useNonLoginPopupStore();
  useEffect(() => {
    openPopup(false);
  }, [openPopup]);

  return (
    <>
      <ErrorPage resetText="되돌아가기" onResetClick={closeCurrentModal} />
      <MarketNonLoginPopup />
    </>
  );
};

export default NonLoginErrorPage;
